import { render, staticRenderFns } from "./ActiveSellCoins.vue?vue&type=template&id=fddf3bfa&scoped=true&"
import script from "./ActiveSellCoins.vue?vue&type=script&lang=ts&"
export * from "./ActiveSellCoins.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveSellCoins.vue?vue&type=style&index=0&id=fddf3bfa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddf3bfa",
  null
  
)

export default component.exports